var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "modal-header" }, [
      _c("h3", { staticClass: "modal-title" }, [
        _vm._v("\n\t\t\tChoisissez un établissement\n\t\t\t"),
        _c(
          "button",
          {
            staticClass: "close",
            attrs: { type: "button", "data-dismiss": "modal" },
            on: {
              click: function ($event) {
                return _vm.modal.dismiss()
              },
            },
          },
          [
            _c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")]),
            _c("span", { staticClass: "sr-only" }, [_vm._v("Close")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "modal-body" },
      [
        _c("sister-shops", {
          attrs: { shop: _vm.myShop },
          on: { "selected-shop": _vm.setShop, "use-shop": _vm.useShop },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "modal-footer" }, [
      _c(
        "div",
        {
          staticClass:
            "modal-bottom bg-white w-100 flex-center-center pos-sticky bottom-0 zindex-1 radius-18 px-10 py-10 shadow-4",
        },
        [
          _c(
            "button",
            {
              staticClass:
                "btnFlat-color2 my-10 mx-10 flex-1 fsize-18 shadow-1",
              on: {
                click: function ($event) {
                  return _vm.useShop(_vm.myShop)
                },
              },
            },
            [
              _c("span", [_vm._v("Continuer")]),
              _vm._v(" "),
              _c("i", { staticClass: "fie-icon_arrow2-r" }),
              _vm._v(" "),
              _c("i", {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.processing,
                    expression: "processing",
                  },
                ],
                staticClass: "loading",
              }),
            ]
          ),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }